/** @jsx jsx */
import { Flex, SemiTitle } from '@bottlebooks/gatsby-theme-base';
import Image from 'gatsby-plugin-sanity-image';
import { jsx } from 'theme-ui';

export default function RegionCard({ region, height, ...rest }) {
  const { mainImage, name } = region;
  const width = 400;
  return (
    <Flex
      direction="column"
      align="center"
      sx={{
        position: 'relative',
        padding: 2,
        background: 'white',
        boxShadow: 'medium',
      }}
      {...rest}
    >
      <Image
        {...mainImage}
        width={Array.isArray(width) ? width[width.length - 1] : width}
        sizes={`(max-width: 40em) ${
          Array.isArray(width) ? width[0] : width
        }px, ${Array.isArray(width) ? width[width.length - 1] : width}px`}
        alt={name}
        sx={{
          objectFit: 'cover',
          // Always ensure the images are full-width
          width: '100%',
          height,
          borderRadius: 'default',
        }}
      />
      <SemiTitle>{name}</SemiTitle>
    </Flex>
  );
}
